import { connect } from 'redaction'
import { constants } from 'common/helpers'

import Countdown from 'components/ui/countdown/Countdown/Countdown'


export default connect({
  startDate: (state) => {
    const {
      models: {
        ui: {
          closedPopups: {
            [constants.popups.notSubscribedCountdown]: countdownData,
          },
        },
      },
    } = state

    // if countdownData exists then countdown is shown in the banner
    return countdownData && countdownData.lastUpdate ? new Date(countdownData.lastUpdate).getTime() : Date.now()
  },
  timeLeftForTimer: (state) => {
    const {
      models: {
        ui: {
          closedPopups: {
            [constants.popups.notSubscribedCountdown]: countdownData,
          },
        },
      },
    } = state

    const oneHour = 1000 * 60 * 60

    /*
      https://scentbird.atlassian.net/browse/SCNT-5276

      we should display banner for one hour, which includes 30 mins of actual countdown plus 30 mins of zeros being
      visible
    */

    if (!countdownData || !countdownData.count) {
      return oneHour
    }

    const timeLeft = Date.now() - new Date(countdownData.lastUpdate).getTime()

    return timeLeft < oneHour
      ? oneHour - timeLeft
      : oneHour
  },
  hideZeroHours: () => true,
  withCloseTimer: () => true,
  popupName: () => constants.popups.notSubscribedCountdown,
  hours: () => 0.5,
})(Countdown)
